import { StoreState } from '../store-interfaces';

export const allTags = (state: StoreState) => state.tags.entities || [];

export const tagsOfKinds = (
  state: StoreState,
  kinds: ('otn' | 'regular' | 'service')[],
) =>
  allTags(state).filter(({ kind }) => kinds.indexOf(kind || 'regular') !== -1);
